import { services } from "@/utils/config/services";
import { customFetch } from "../customFetch";
import { NotificationPreference } from "../types/response/users";

interface BaseUser {
  firstName: string;
  lastName: string;
}

interface UpdateNotificationPreferences {
  areEmailNotificationsEnabled: boolean;
  areInAppNotificationsEnabled: boolean;
  preferences: NotificationPreference[];
}

interface UpdateUser extends BaseUser {
  suspended: boolean;
}

interface AddUser extends BaseUser {
  companyId: string;
  email: string;
}

export const users = {
  getRoles: () => customFetch(`${services.roles}`),
  getUsers: (page: number, pageSize: number, companyId: string) =>
    customFetch(
      `${services.users}?CompanyId=${companyId}&PageNumber=${page}&PageSize=${pageSize}`,
    ),
  getUser: (id: string) => customFetch(`${services.users}/${id}`),
  assignRole: async (
    rolesToAssign: string[],
    rolesToDelete: string[],
    userId: string,
  ) => {
    await customFetch(`${services.users}/${userId}/roles`, {
      method: "POST",
      body: JSON.stringify({
        roleIds: rolesToAssign,
      }),
    });
    if (rolesToDelete.length)
      await customFetch(`${services.users}/${userId}/roles`, {
        method: "DELETE",
        body: JSON.stringify({
          roleIds: rolesToDelete,
        }),
      });
  },
  addUser: (payload: AddUser) =>
    customFetch(`${services.users}/create-user`, {
      method: "POST",
      body: JSON.stringify(payload),
    }),
  updateUser: (userId: string, payload: UpdateUser) =>
    customFetch(`${services.users}/${userId}`, {
      method: "PUT",
      body: JSON.stringify(payload),
    }),
  deleteUser: (userId: string) =>
    customFetch(`${services.users}/${userId}`, {
      method: "DELETE",
    }),
  resetUserMfa: (userId: string) =>
    customFetch(`${services.users}/${userId}/reset-multi-factor`, {
      method: "POST",
    }),
  getNotificationPreferences: (companyId: string) =>
    customFetch(
      `${services.users}/me/notification-preferences?CompanyId=${companyId}`,
    ),
  updateNotificationPreferences: (payload: UpdateNotificationPreferences) =>
    customFetch(`${services.users}/me/notification-preferences`, {
      method: "PUT",
      body: JSON.stringify(payload),
    }),
  getUserNotificationPreferences: (userId: string, companyId: string) =>
    customFetch(
      `${services.users}/${userId}/notification-preferences?CompanyId=${companyId}`,
    ),
  updateUserNotificationPreferences: (
    userId: string,
    payload: UpdateNotificationPreferences,
  ) =>
    customFetch(`${services.users}/${userId}/notification-preferences`, {
      method: "PUT",
      body: JSON.stringify(payload),
    }),
};
